import client from './client'
import { buildListParams } from '../utils/pagination'

export function favoriteTrack(trackId) {
  return client.post(`/api/v1/tracks/${trackId}/favorite`)
}

export function unfavoriteTrack(trackId) {
  return client.delete(`/api/v1/tracks/${trackId}/favorite`)
}

export function favoriteUser(userId) {
  return client.post(`/api/v1/users/${userId}/favorite`)
}

export function unfavoriteUser(userId) {
  return client.delete(`/api/v1/users/${userId}/favorite`)
}

export function fetchFavoriteTracks({ page, perPage, season, wheelSize } = {}) {
  const params = buildListParams({ page, perPage, season, wheelSize })
  return client.get('/api/v1/favorites/tracks', { params })
}

export function fetchFavoriteUsers({ page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get('/api/v1/favorites/users', { params })
}
